export const naturalSort = (values: string[]) => {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    return values.sort(collator.compare);
}
